import React from 'react';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import { LegalLineDescription, LegalLinesSection, LegalLineText } from './LegalLinesStyle';

const LegalLines = ({ context }: IContext) => {
  return (
    <LegalLinesSection>
      {context.legal.legalLines.map((legalText,index) => (
        <LegalLineText
          dangerouslySetInnerHTML={{ __html: legalText }}
          key={"legal_line " + index}
        />
      ))}
    </LegalLinesSection>
  );
};

export default withContent(LegalLines);

